module.exports = "/img/icon-sports.svg?9b955718222db929795f1dd616804963";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/img/icon-sports.svg
// module id = RL9+
// module chunks = 46